/**
* Lottie Animation JS
* -----------------------------------------------------------------------------
*
* All the JS for the Lottie Animation component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'lottie-animation',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.lottie-animation' ).each( function( key, val ) {
        let autoplay = false;

        if ( $( val ).attr( 'data-trigger' ) == 'init' ) {
          autoplay = true;
        }

        const animation = lottie.loadAnimation( {
          container: this, // the dom element that will contain the animation
          renderer: 'svg',
          loop: $( val ).attr( 'data-infinite' ).length ? true : false,
          autoplay: autoplay,
          path: $( val ).attr( 'data-url' ), // the path to the animation json
        } );

        if ( $( val ).attr( 'data-trigger' ) == 'hover' ) {
          autoplay = true;

          $( val ).on( 'mouseover', function() {
            animation.play();
          } ).on( 'mouseout', function() {
            animation.stop();
          } );
        } else if ( $( val ).attr( 'data-trigger' ) == 'scroll' ) {
          autoplay = true;

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 75%',
              end: 'bottom top',
              scrub: 0,
              refreshPriority: -1,
              markers: true,
              onEnter: ( self ) => {
                animation.goToAndPlay( 0 );
              },
              onLeave: ( self ) => {
                animation.stop();
              },
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'lottie-animation', COMPONENT );
} )( app );
